import { useEffect, useState } from "react";

import { AdminBanner } from "~/api/banner.types";
import { Modal } from "~/ui/common";

interface DeleteConfirmDialogProps {
  show: boolean;
  banner: AdminBanner | null;
  onConfirm: () => void;
  onClose: () => void;
  isLoading: boolean;
}

export const DeleteConfirmDialog = ({
  show,
  banner,
  onConfirm,
  onClose,
  isLoading,
}: DeleteConfirmDialogProps) => {
  const [step, setStep] = useState<1 | 2>(1);

  useEffect(() => {
    if (!show) setStep(1);
  }, [show]);

  if (!banner) return null;

  if (step === 1) {
    return (
      <Modal
        show={show}
        title="Delete banner"
        onClose={onClose}
        handleConfirm={banner.is_active ? () => setStep(2) : onConfirm}
        confirmLabel="Delete"
        isLoading={false}
      >
        <p className="text-lg text-neutral-600">
          Are you sure you want to delete this banner? This action cannot be
          undone.
        </p>
      </Modal>
    );
  }

  return (
    <Modal
      show={show}
      title="Delete active banner"
      onClose={onClose}
      handleConfirm={onConfirm}
      confirmLabel="Yes, delete it"
      isLoading={isLoading}
    >
      <p className="text-lg text-neutral-600">
        This banner is currently active and visible to all hub users. Deleting
        it will immediately remove it from the hub. Are you sure?
      </p>
    </Modal>
  );
};
